import React from "react";
import BaseTextButton from "../../../../../../components/BaseTextButton";
import "./style.scss";
import { useTranslation } from "react-i18next";
import ROUTES from "../../../../../../utils/routes.js";
function RecoverButton() {
  const { t } = useTranslation();
  return (
    <div className="recover-btn-wrapper">
      <BaseTextButton to={ROUTES.RECOVERY_PAGE} className="btn-recover">
        {t("login_page.recover_btn")}
      </BaseTextButton>
    </div>
  );
}

export default RecoverButton;
